import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container } from 'react-bootstrap'
import { getPastScore } from '../hooks/question'

const mapStateToProps = (state) => {
  return {
    question: state.question,
    baseline: state.baseline
  }
}


const mapDispatchToProps = dispatch => ({
  getPastScore: () => dispatch(getPastScore())
});


const getColour = (cas, baseline, is_baseline) => {
  var cas_score = parseInt(baseline)
  var current = parseInt(cas)
  if(is_baseline) {
    return "base-cas-score"
  }
  if (current > cas_score) {
    return "green-cas-score"
  } else if (current ===cas_score) {
    return "yellow-cas-score"
  } else if(current < cas_score) {
    return "red-cas-score"
  }
}

class DailyAlertness extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {

    };
    this.props.getPastScore()
  }

  render() {
    return <Fragment>

      <NavbarComp access_token={true}/>
      <div className="page-sections">
        <div className='daily-alert-wrap'>
          <Container>
            <div className='daily-alert-contents'>
              <h2 className='main-title-style'>YOUR DAILY ALERTNESS</h2>
              <div className='shift-and-cas-wrap'>
                <div className='shift-and-cas'>
                  <span className='shift-alert'>SHIFT</span>
                  <div className='cas-alert-score'><span className='shift-alert'>CAS</span></div>
                </div>
                {this.props.question.score !== null ?
                  this.props.question.score.map((score, index) => {
                    return <div key={index} className='shift-and-cas'>
                      <span><strong>{index + 1}:</strong> {score.day_name} {score.test_date}</span>
                      <div className={'cas-alert-score ' + (getColour(score.cas, score.baseline, score.is_baseline))}><span>{parseInt(score.cas)}</span></div>
                    </div>
                  })
                  : null}
              </div>
              <a href="/dashboard" rel="nofollow"><button className='dashboard-btn'>DASHBOARD</button></a>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp />

    </Fragment>
  }
}

DailyAlertness.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DailyAlertness);
